import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faClock,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const Topbar = () => {
  return (
    <div className="topbar">
      <div id="topbar" className="d-flex align-items-center">
        <div className="container d-flex justify-content-between">
          <div className="contact-info d-flex flex-row align-items-center">
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              <a href="mailto:pneumotherapy@yahoo.com">
                pneumotherapy@yahoo.com
              </a>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} className="contact-icon" />
              <a href="tel:0725596895">0725 596 895</a>
            </div>
            <div className="contact-item d-none d-md-flex">
              <FontAwesomeIcon icon={faClock} className="contact-icon" />
              <span>Luni-Vineri: 08:00 – 21:00</span>
            </div>
          </div>

          <div className="d-none d-lg-flex social-links align-items-center">
            <a
              href="https://www.facebook.com/people/Ali-Cranta-Medical-Center/61564992072140/"
              className="social-icon"
              aria-label="Facebook Ali Cranta Medical Center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>

            <a
              href="https://www.linkedin.com/in/ali-cranta-2ba65026/"
              className="social-icon"
              aria-label="LinkedIn Dr. Ali Cranta"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>

            <a
              href="https://www.alicrantamedicalcenter.com/"
              className="social-icon"
              aria-label="Ali Cranta Medical Center Website"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faGlobe} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
